import { ROUTES } from "./routes";

const footerSections = [
  {
    title: "Company",
    links: [
      {
        label: "Our Story",
        link: "/our-story",
      },
      {
        label: "About",
        link: "/about-us",
      },
      // {
      //   label: 'Careers',
      // },
      {
        label: "Press",
        link: "https://www.linkedin.com/newsletters/haystackers-weekly-harvest-7190419915835658240/",
      },
      {
        label: "Blog",
        link: "/blogs",
      },
    ],
  },
  {
    title: "Renters",
    links: [
      {
        label: "Search Tractors",
        link: ROUTES.SEARCH_LISTING,
      },
      // {
      //   label: "Return Policy",
      // },
      {
        label: "FAQs",
        link: "/faq",
      },
    ],
  },
  {
    title: "Owners",
    links: [
      {
        label: "List Tractors",
        link: ROUTES.EQUPIMENT_LISTING,
      },
      // {
      //   label: "Listing Policy",
      // },
      {
        label: "FAQs",
        link: "/faq",
      },
    ],
  },
  {
    title: "Support",
    links: [
      {
        label: "How it works",
        link: ROUTES.HOW_IT_WORKS,
      },
      {
        label: "Help Center",
      },
      // {
      //   label: "Chat, Email or Call Us",
      //   link: "openChat",
      // },
      // {
      //   label: "Give Feedback",
      // },
    ],
  },
];

export default footerSections;
